const { Criteria } = Shopware.Data;

/**
 * Synonyme: "elf bar" -> "elfbar", "e-zigarette" -> "ezigarette, vape".
 * Beidseitig bedeutet, dass die Suche in beide Richtungen funktioniert.
 * Ersatzbegriffe werden mit Komma getrennt eingegeben.
 */
export default {
    template: `
<sw-page class="riccardo-search-synonyms">
    <template #smart-bar-header><h2>Suche – Synonyme</h2></template>
    <template #smart-bar-actions>
        <sw-button :router-link="{ name: 'riccardo.search.terms' }">Auswertung</sw-button>
        <sw-button variant="primary" @click="neu">Synonym anlegen</sw-button>
    </template>
    <template #content>
        <div style="padding: 24px;">
            <sw-card :is-loading="isLoading" title="Synonyme">
                <p style="color:#798490">
                    Wird ein Begriff gesucht, sucht der Shop die Ersatzbegriffe gleich mit (ODER-Verknüpfung).
                    Mehrere Ersatzbegriffe mit Komma trennen.
                </p>
                <sw-entity-listing v-if="items" :items="items" :repository="repository" :columns="columns"
                                   :show-selection="true" :allow-inline-edit="true" :full-page="false"
                                   @inline-edit-save="speichern" detail-route="">
                    <template #column-bothWays="{ item }">
                        <sw-icon :name="item.bothWays ? 'regular-checkmark-xs' : 'regular-times-xs'"
                                 :color="item.bothWays ? '#37D046' : '#DE294C'" small />
                    </template>
                    <template #column-active="{ item }">
                        <sw-icon :name="item.active ? 'regular-checkmark-xs' : 'regular-times-xs'"
                                 :color="item.active ? '#37D046' : '#DE294C'" small />
                    </template>
                </sw-entity-listing>
            </sw-card>
        </div>

        <sw-modal v-if="entwurf" title="Synonym anlegen" @modal-close="entwurf = null" variant="small">
            <sw-text-field v-model:value="entwurf.term" label="Gesuchter Begriff" placeholder="elf bar" />
            <sw-text-field v-model:value="entwurf.replacements" label="Ersatzbegriffe (Komma getrennt)"
                           placeholder="elfbar, elfbar 600" />
            <sw-switch-field v-model:value="entwurf.bothWays" label="Beidseitig" />
            <sw-switch-field v-model:value="entwurf.active" label="Aktiv" />
            <sw-text-field v-model:value="entwurf.comment" label="Notiz" />
            <template #modal-footer>
                <sw-button size="small" @click="entwurf = null">Abbrechen</sw-button>
                <sw-button variant="primary" size="small" :disabled="!entwurf.term || !entwurf.replacements"
                           @click="anlegen">Anlegen</sw-button>
            </template>
        </sw-modal>
    </template>
</sw-page>`,

    inject: ['repositoryFactory'],

    data() {
        return { items: null, isLoading: false, entwurf: null };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('riccardo_search_synonym');
        },
        columns() {
            return [
                { property: 'term', label: 'Begriff', primary: true, inlineEdit: 'string' },
                { property: 'replacements', label: 'Ersatzbegriffe', inlineEdit: 'string' },
                { property: 'bothWays', label: 'Beidseitig', inlineEdit: 'boolean', align: 'center' },
                { property: 'active', label: 'Aktiv', inlineEdit: 'boolean', align: 'center' },
                { property: 'comment', label: 'Notiz', inlineEdit: 'string' },
            ];
        },
    },

    created() {
        this.laden();
        // Aus der Auswertung heraus: ?term=... legt direkt einen Entwurf an.
        if (this.$route.query.term) {
            this.neu(this.$route.query.term);
        }
    },

    methods: {
        laden() {
            this.isLoading = true;
            const criteria = new Criteria(1, 50);
            criteria.addSorting(Criteria.sort('term', 'ASC'));
            this.repository.search(criteria, Shopware.Context.api)
                .then((r) => { this.items = r; })
                .finally(() => { this.isLoading = false; });
        },
        neu(term) {
            const e = this.repository.create(Shopware.Context.api);
            e.term = typeof term === 'string' ? term : '';
            e.replacements = '';
            e.bothWays = true;
            e.active = true;
            this.entwurf = e;
        },
        anlegen() {
            this.repository.save(this.entwurf, Shopware.Context.api).then(() => {
                this.entwurf = null;
                this.laden();
                this.hinweis('Synonym gespeichert. Wirkt sofort, der Zwischenspeicher hält 5 Minuten.');
            });
        },
        speichern() {
            this.laden();
        },
        hinweis(text) {
            Shopware.Store.get('notification').createNotification({ variant: 'success', message: text });
        },
    },
};
